import { ListGroup } from "react-bootstrap";
import { Link } from "react-router-dom";
import Query from "../common/Query";
import { FormContainerConfig } from "../form/types";
import FORMS_QUERY from "./queries/FORMS_QUERY";

const FormsView = () => {
  return (
    <Query loadingLabel="Loading Your Forms" query={FORMS_QUERY}>
      {({ data: { forms } }: { data: { forms: FormContainerConfig[] } }) => {
        return (
          <>
            <h1>Forms</h1>
            <ListGroup>
              {forms.map((f) => (
                <ListGroup.Item key={f.id}>
                  {f.title}{" "}
                  <Link to={`/form/${f.id}`}>view</Link>{" "}
                  <Link to={`/forms/${f.id}`}><span className="badge bg-primary rounded-pill float-end">{f.submissionCount}</span></Link>
                </ListGroup.Item>
              ))}
            </ListGroup>
          </>
        );
      }}
    </Query>
  );
};

export default FormsView;
